import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { defineChain } from 'viem'


import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { bscTestnet } from 'viem/chains'


export const BROCK = defineChain({
  id: 7171,
  name: 'Bitrock Mainnet',
  network: 'Bitrock Mainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'BROCK',
    symbol: 'BROCK',
  },
  rpcUrls: {

    default: {
      http: ['https://brockrpc.io'],
      webSocket: ['wss://rpc.zora.energy'],
    },
    public: {
      http: ['https://brockrpc.io'],
      webSocket: ['wss://rpc.zora.energy'],
    },
  },

  blockExplorers: {
    default: { name: 'Explorer', url: 'https://explorer.bit-rock.io' },
  },

})

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = 'da4a78c96fcd7382b38cf36b9959078e'

// 2. Create wagmiConfig
const metadata = {
  name: 'Web3Modal',
  description: 'Web3Modal Example',
  url: 'https://web3modal.com',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [BROCK]
const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableAnalytics: true // Optional - defaults to your Cloud configuration
})

// 3. Create modal
createWeb3Modal({ wagmiConfig, projectId, chains })


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>

    <WagmiConfig config={wagmiConfig}>
      <App />
    </WagmiConfig>
  </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
